<template>
	<div class="link-container" @mouseleave="showSecondary = false">
	    <a :href="'/'+data['url']" :class="{'active': active}" class="nav-link" @mouseover="showSecondary = true">
	      {{ data['name'] }} 
	    </a>
	      <div class="secondary-links-container" v-if="data['secondary']">
	        <div class="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
	          <div class="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8 lg:grid-cols-2" v-if="showSecondary">
	            <a :href="'/'+secondary['url']" class="-m-3 p-3 flex items-start rounded-lg hover:bg-gray-50 no-underline" v-for="secondary in data['secondary']">
	              <div v-if="secondary['icon']" class="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-md bg-teal-500 text-white sm:h-12 sm:w-12">
	                <i class="text-lg" :class="secondary['icon']"></i>
	              </div>
	              <div class="ml-4">
	                <p class="text-base font-medium text-gray-900">
	                  {{ secondary['name'] }}
	                </p>
	                <p class="mt-1 text-sm text-gray-500" v-if="secondary['description']">
	                  {{ secondary['description'] }}
	                </p>
	              </div>
	            </a>
	          </div>
	        </div>
	      </div>
  </div>
</template>

<script>
	export default {
		name: 'navLink',
		props: {
			data: {},
			active: {}
		},
		data() {
			return {
				showSecondary: false,
			}
		}
	}
</script>